import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BCard, BCardText, BLink } from "bootstrap-vue";
import { computed, onMounted, ref, watchEffect } from "vue";
import localize from "@/utils/localization";
import { wait } from "@/utils/utils";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CleanupOperationSummary',
    props: {
        operation: null,
        refreshOperationId: { default: undefined },
        refreshDelay: { default: 500 }
    },
    emits: ["onReviewItems"],
    setup(__props, { emit }) {
        const props = __props;
        const summary = ref();
        const loading = ref(true);
        const errorMessage = ref();
        const canClearItems = computed(() => {
            return (summary.value?.totalItems ?? 0) > 0;
        });
        onMounted(async () => {
            await refresh();
        });
        watchEffect(async () => {
            if (props.operation.id === props.refreshOperationId) {
                await refresh();
            }
        });
        async function refresh() {
            loading.value = true;
            try {
                const start = Date.now();
                summary.value = await props.operation.fetchSummary();
                const duration = Date.now() - start;
                await wait(props.refreshDelay - duration);
            }
            catch (error) {
                onError(String(error));
            }
            finally {
                loading.value = false;
            }
        }
        function onError(message) {
            errorMessage.value = message;
        }
        function onReviewItems() {
            emit("onReviewItems", props.operation, summary.value?.totalItems ?? 0);
        }
        return { __sfc: true, props, summary, loading, errorMessage, canClearItems, emit, refresh, onError, onReviewItems, BAlert, BCard, BCardText, BLink, localize, LoadingSpan };
    }
});
